import { _$id, } from '../util/dom';
import { _routes, } from './route-registry';
import { _addUnitChangeHandler, } from './distance-units';
const _attachLengthDisplay = (route) => {
    const $lengthDisplay = route.len().d();
    _$ldForm.appendChild($lengthDisplay);
}, _removeLengthDisplay = (route) => {
    const $lengthDisplay = route.len().d();
    _$ldForm.removeChild($lengthDisplay);
}, _updateAllLengthDisplays = () => {
    const routes = _routes();
    for (const route of routes) {
        route.len().setU();
    }
}, _$ldForm = _$id('length-displays');
_addUnitChangeHandler(_updateAllLengthDisplays);
export { _attachLengthDisplay, _removeLengthDisplay, _$ldForm, };
